import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { PERMISSION, VENUE_SOURCE } from 'constants/logic';
import { userHasPermission } from 'helpers/core';
import { selectActiveVenue, selectUserVenues, selectUserInfo } from 'selectors/general';
import { getTermsUrl, makePath } from 'helpers/link-generation';
import { locales } from 'helpers/supported-locales';
import { userInfo } from 'store/saga/entities/bound';
import Settings from './Settings';
import { updateLocale, updatePassword } from './Settings.saga';
import { selectEmailBounceStatus } from './Settings.selectors';

export const shouldShowFrontdeskLink = (venueId, venueList, user) => {
  const source = (venueList.find(v => v.venueId === venueId) || {}).venueSource;
  const canMigrateToFrontDesk = userHasPermission(user, PERMISSION.CAN_MIGRATE_TO_FRONTDESK);
  return [VENUE_SOURCE.CLASSTIVITY, VENUE_SOURCE.MSINVENTORY].includes(source) && canMigrateToFrontDesk;
};

export const mapStateToProps = (state, ownProps) => {
  const { intl } = ownProps;
  const isLoaded = userInfo.loaded(state);
  const user = selectUserInfo(state);
  const { venueId: activeVenueId } = selectActiveVenue(state);
  const venuesList = selectUserVenues(state);
  const { locale } = intl;
  const brazeEmailIsBounced = selectEmailBounceStatus(state);

  return {
    isLoaded,
    venueId: activeVenueId,
    languages: locales,
    standardTermsUrl: getTermsUrl(venuesList, activeVenueId),
    venues: venuesList,
    frontdeskUrl: makePath.pike13(activeVenueId),
    showFrontdeskLink: shouldShowFrontdeskLink(activeVenueId, venuesList, user),
    user,
    locale,
    brazeEmailIsBounced,
  };
};

const mapDispatchToProps = {
  handleChangeLocale: updateLocale,
  handlePasswordUpdate: (formValues, formAsyncFns) => updatePassword(formValues.password, formAsyncFns),
};

export default compose(injectIntl, connect(mapStateToProps, mapDispatchToProps))(Settings);
